import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { Injectable, ComponentRef } from '@angular/core';

import { ToastBannerComponent } from '../../toast-banner/toast-banner.component';

@Injectable({
  providedIn: 'root',
})
export class BlackSimpleToasterService {
  // Modal Warning
  private overlayRef?: OverlayRef;
  private portalRef?: ComponentPortal<ToastBannerComponent>;
  private ref?: ComponentRef<ToastBannerComponent>;

  // Status
  private warningInProgress = false;

  public constructor(private overlay: Overlay) {}

  public throw(message: string, buttonTitle: string, callback?: () => void): void {
    if (this.warningInProgress === true) {
      return;
    }

    // Flag
    this.warningInProgress = true;
    // Modal
    this.overlayRef = this.overlay.create({ width: '100%' });
    this.portalRef = new ComponentPortal(ToastBannerComponent);
    this.ref = this.overlayRef.attach(this.portalRef);
    this.ref.instance.message = message;
    this.ref.instance.buttonTitle = buttonTitle;
    // on Close
    this.ref.instance.eventSubject.subscribe((close) => {
      if (close && callback) {
        callback();
      }
    });
  }

  public close(): void {
    // Flag
    this.warningInProgress = false;
    // Modal
    this.overlayRef?.detach();
    this.portalRef = undefined;
    this.overlayRef = undefined;
    this.ref = undefined;
  }
}
